import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { FromPriceDisclaimers } from "./FromPriceDisclaimers.js";
import { useProductData } from "../../../../../../../../../../../../context/context/product-context-hooks.js";
import { isSunglasses, isFrames } from "../../../../../../../../../../../../types/types/typeguards.js";
const FromPriceDisclaimersContainer = () => {
  const { getLabel } = useIntl();
  const { product } = useProductData();
  let props = {};
  const labelOptions = {
    hideLabelKey: true
  };
  if (isSunglasses(product)) {
    props = {
      includesLabel: getLabel("products.price.sunglasses.disclaimerIncludes", labelOptions),
      excludesLabel: getLabel("products.price.sunglasses.disclaimerExcludes", labelOptions),
      excludesTooltipLabel: getLabel(
        "products.price.sunglasses.disclaimerExcludesTooltip",
        labelOptions
      )
    };
  }
  if (isFrames(product)) {
    props = {
      includesLabel: getLabel("products.price.frames.disclaimerIncludes", labelOptions),
      excludesLabel: getLabel("products.price.frames.disclaimerExcludes", labelOptions),
      excludesTooltipLabel: getLabel(
        "products.price.frames.disclaimerExcludesTooltip",
        labelOptions
      )
    };
  }
  return /* @__PURE__ */ React.createElement(FromPriceDisclaimers, { ...props });
};
export {
  FromPriceDisclaimersContainer
};
//# sourceMappingURL=FromPriceDisclaimersContainer.js.map
